import { useState, useEffect } from "react";

const useTooltip = (product, isWebView) => {
    const [wasTruncated, setWasTruncated] = useState(false);
    const [truncatedText, setTruncatedText] = useState("");
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
      if (product?.name) {
        const limit = !isWebView ? ((!product.picture || !product.image) ? 22 : 30) : ((!product.picture || !product.image) ? 25 : 33);
        const truncated = product.name.length > limit;
        setWasTruncated(truncated);
        setTruncatedText(truncated ? product.name.slice(0, limit) + "..." : product.name);
      }
    }, [product, isWebView]);

    return {
        wasTruncated,
        truncatedText,
        showTooltip,
        setShowTooltip,
        tooltipPosition,
        setTooltipPosition
    };
};

export default useTooltip;
